import {
  AbortMultipartVideoUploadRequest,
  AbortMultipartVideoUploadResponse,
  CompleteMultipartVideoUploadRequest,
  CompleteMultipartVideoUploadResponse,
  GetMultipartVideoUploadUrlsRequest,
  GetMultipartVideoUploadUrlsResponse,
  InitializeMultipartVideoUploadRequest,
  InitializeMultipartVideoUploadResponse,
} from '@eigtech/meetings-types'
import { OmitAuthHeaders, contextualPost, useMutation } from '@eigtech/ui-shared-api'
import { meetingsBasePath } from './constants'

const multipartPath = `${meetingsBasePath}/meeting/video/multipart-upload`

export const initializeMultipartVideoUpload = ({
  entityId,
  ...payload
}: OmitAuthHeaders<InitializeMultipartVideoUploadRequest>) =>
  contextualPost<InitializeMultipartVideoUploadResponse>(
    `${multipartPath}/init/${entityId}`,
    payload,
    { responseType: 'json' }
  )

export const getMultipartVideoUploadUrls = ({
  entityId,
  ...payload
}: OmitAuthHeaders<GetMultipartVideoUploadUrlsRequest>) =>
  contextualPost<GetMultipartVideoUploadUrlsResponse>(
    `${multipartPath}/urls/${entityId}`,
    payload,
    { responseType: 'json' }
  )

export const completeMultipartVideoUpload = ({
  entityId,
  ...payload
}: OmitAuthHeaders<CompleteMultipartVideoUploadRequest>) =>
  contextualPost<CompleteMultipartVideoUploadResponse>(
    `${multipartPath}/complete/${entityId}`,
    payload,
    { responseType: 'none' }
  )

export const abortMultipartVideoUpload = ({
  entityId,
  ...payload
}: OmitAuthHeaders<AbortMultipartVideoUploadRequest>) =>
  contextualPost<AbortMultipartVideoUploadResponse>(`${multipartPath}/abort/${entityId}`, payload, {
    responseType: 'none',
  })

export const useInitializeMultipartVideoUpload = () =>
  useMutation({
    mutationFn: initializeMultipartVideoUpload,
  })

export const useGetMultipartVideoUploadUrls = () =>
  useMutation({
    mutationFn: getMultipartVideoUploadUrls,
  })

export const useCompleteMultipartVideoUpload = () =>
  useMutation({
    mutationFn: completeMultipartVideoUpload,
  })

export const useAbortMultipartVideoUpload = () =>
  useMutation({
    mutationFn: abortMultipartVideoUpload,
  })
